












































































































































































































import Vue from 'vue';
import $ from 'jquery';
import 'bootstrap-select';
import { en } from '../assets/js/en.characters';
import { fr } from '../assets/js/fr.characters';
import { cn } from '../assets/js/cn.characters';
import { tw } from '../assets/js/tw.characters';
import { nicknames } from '../assets/js/nicknames';

export default Vue.extend({
  props: ['title', 'value', 'huid'],
  data() {
    return {
      characters: en,
      nicknames,
      modalid: 'temp',
      selectedCharacters: '',
      selectedAttributes: 'fire',
      selectedRarity: '3',
      selectedRole: 'warrior',
    };
  },
  created() {
    this.characters = this.getItems();
    this.modalid = this.huid;
  },
  computed: {
    getCharacter(): Array<any> {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 100);
      return this.getItems();
    },
  },
  watch: {
    title(): void {
      this.characters = this.getItems();
    },
  },
  updated() {
    $(this.$el).selectpicker({ title: this.title }).selectpicker('render');
  },
  methods: {
    select($event: Event): void {
      this.selectedCharacters = ($event.target as HTMLInputElement).value;
      this.$emit('input', ($event.target as HTMLInputElement).value);
      this.$emit('selectCharacter', this.selectedRole);
    },
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    getItems(): Array<any> {
      let characters = null;
      const filteredCharacters = [];
      switch (this.$i18n.locale) {
        case 'en':
          characters = en;
          break;
        case 'fr':
          characters = fr;
          break;
        case 'cn':
          characters = cn;
          break;
        case 'tw':
          characters = tw;
          break;
        default:
          characters = en;
          break;
      }
      for (let i = 0; i < characters.length; i += 1) {
        if (
          characters[i].rarity.toString() === this.selectedRarity &&
          characters[i].attribute === this.selectedAttributes &&
          characters[i].role === this.selectedRole
        ) {
          filteredCharacters.push(characters[i]);
        }
      }

      return filteredCharacters;
    },
    getTokens(item: { _id: string }): string {
      if (item._id && nicknames[item._id]) {
        return nicknames[item._id];
      }
      return '';
    },
  },
});
